export default __webpack_public_path__ + "static/media/airdockz-bpk-4.f3c9b97a.png";